module.exports = __webpack_public_path__ + "static/media/30_B.b2200c94.png";